<template>
  <page-outline :title="$t('Webheader.entity_account')">
    <template slot="pageContent">
      <b-container fluid>
        <div class="requestsList">
          <div class="mt-0">
            <div>
              <b-row class="text-xl-start mb-3">
                <b-col xl="6" lg="9" md="12" cols="12">
                  <b-button-group class="mt-3 mt-sm-0">
                    <b-button class="px-4" :variant="tabName === 1 ? 'primary btn-selected' : ''" @click="changeTabName(1)">{{ $t('Webheader.entity_account_file') }}</b-button>
                    <b-button class="px-4" :variant="tabName === 2 ? 'primary btn-selected' : ''" @click="changeTabName(2)">{{ $t('Webheader.iban_history') }}</b-button>
                  </b-button-group>
                </b-col>
              </b-row>
              <EntityAccountFileList v-if="tabName === 1"></EntityAccountFileList>
              <EntityAccountList v-if="tabName === 2"></EntityAccountList>
            </div>
          </div>
        </div>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import EntityAccountList from '@/pages/entityAccount/EntityAccountList.vue'
import EntityAccountFileList from '@/pages/entityAccount/EntityAccountFileList.vue'

export default {
  name: 'EntityAccountPage',
  components: {
    EntityAccountList,
    EntityAccountFileList,
    'page-outline': PageOutline,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'EntityAccountFile',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  data () {
    return {
      tabName: 1
    }
  },
  created () {
    if (this.type === 'EntityAccountFile') {
      this.tabName = 1
    } else if (this.type === 'EntityAccount') {
      this.tabName = 2
    }
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  methods: {
    changeTabName (tabName) {
      this.tabName = tabName
    }
  }
}
</script>
